import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import Signup from "../components/Signup";
import SignupOptions from "../components/SignupOptions";
import { useFlags } from "../../../../config/featureFlags";
import { useQuery } from "../../../../utils/hooks/useQuery";
import {authFacebook} from "../_redux/authCrud";

const steps = {
  SIGNUP_OPTIONS: 1,
  SIGNUP_FORM: 2,
};

function Registration(props) {
  const { DISPLAY_LIKUMI_CONTENT, DISPLAY_CODE_CONTENT } = useFlags();
  // Skip the registration of the team for CODE --- done in background see Signup.tsx
  const [step, setStep] = useState(steps.SIGNUP_FORM);

  const queryParams = useQuery();
  const email = queryParams.get("email");
  const invitationToken = queryParams.get("invitationToken");

  useEffect(() => {
    if (email && DISPLAY_LIKUMI_CONTENT) {
      setStep(steps.SIGNUP_FORM);
    }
  }, [email, DISPLAY_LIKUMI_CONTENT]);

  const responseFacebook = (accessToken) => {
    authFacebook(accessToken)
      .then(({ data: { accessToken } }) => {
        localStorage.setItem("accessToken", accessToken);
        props.login(accessToken);
      })
      .catch((err) => {})
      .finally(() => {
        window.location.reload();
      });
  };

  return (
    <div className="login-signin" style={{ display: "block", width: "500px" }}>
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">

          {
            (DISPLAY_CODE_CONTENT) ?
              <FormattedMessage id="CODE.AUTH.REGISTER.WELCOME" /> :
              <FormattedMessage id="AUTH.REGISTER.WELCOME" />
          }

        </h3>
      </div>
      {
        {
          [steps.SIGNUP_OPTIONS]: <SignupOptions setStep={setStep} />,
          [steps.SIGNUP_FORM]: (
            <Signup
              intl={props.intl}
              propRegister={props.register}
              email={email}
              invitationToken={invitationToken}
              responseFacebook={responseFacebook}
            />
          ),
        }[step]
      }
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Registration));
